import React from "react";
import { Helmet } from "react-helmet";

/* This reusable React component will manage all of your changes to the document head.
https://github.com/nfl/react-helmet/blob/master/README.md */
export const SEO_CONFIG = "seoconfig";

const DocumentHead = ({ pageTitle, description, canonical }) => {
    return (
        <Helmet>
            {pageTitle && <title>{pageTitle.replace("<sup>MC</sup>", "🅪")}</title>}
            {description && <meta name="description" content={description} />}
            {canonical && <link rel="canonical" href={canonical} />}
        </Helmet>
    );
};

export default DocumentHead;